import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { MyListsPage } from './MyListsPage';
import { ListDetailPage } from './ListDetailPage';
import { CompletedTimelinePage } from './CompletedTimelinePage';

export function TodoListsArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<MyListsPage />} />
        <Route path="/:listId" element={<ListDetailPage />} />
        <Route path="/:listId/completed" element={<CompletedTimelinePage />} />
      </Routes>
    </ArcheLayout>
  );
}
